<!-- Search Bar -->
<div class="row border rounded mb-1 ms-1 me-1 pt-2 pb-2">
    <form id="SearchBarForm2" role="form" class="m-0">
        <div class="row row-cols-lg-auto g-2 align-items-center">
            <div class="col-12">
                <label for="TruckerName" class="col-form-label-sm">Name:</label>
            </div>
            <div class="col-12">
                <input type="text" id="TruckerName" #truckerNameInput name="TruckerName" class="form-control form-control-sm" (keydown)="onEnter($event)" [(ngModel)]="truckerSearchParams.customerName" (ngModelChange)="checkParametersChange()" />
            </div>

            <div class="col-12">
                <label for="truckerCity" class="col-form-label-sm">City:</label>
            </div>
            <div class="col-12">
                <input type="text" id="truckerCity" name="truckerCity" class="form-control form-control-sm" (keydown)="onEnter($event)" [(ngModel)]="truckerSearchParams.city" (ngModelChange)="checkParametersChange()" />
            </div>

            <div class="col-12">
                <label for="truckerCode" class="col-form-label-sm">Code:</label>
            </div>
            <div class="col-12">
                <input type="text" id="truckerCode" name="truckerCode" class="form-control form-control-sm" (keydown)="onEnter($event)" [(ngModel)]="truckerSearchParams.customerCode" (ngModelChange)="checkParametersChange()" />
            </div>

            <div class="col-12">
                <span class="col-form-label-sm">Used Between:</span>
            </div>
            <div class="col-12">
                <input type="date" id="truckerStartDate" name="truckerStartDate" class="form-control form-control-sm" (keydown)="onEnter($event)" [(ngModel)]="truckerSearchParams.truckerStartDate" (ngModelChange)="checkParametersChange()" />
            </div>
            <div class="col-12">
                <input type="date" id="truckerEndDate" name="truckerEndDate" class="form-control form-control-sm" (keydown)="onEnter($event)" [(ngModel)]="truckerSearchParams.truckerEndDate" (ngModelChange)="checkParametersChange()" />
            </div>

            <div class="col-12">
                <button type="button" class="btn btn-sm btn-primary ms-1 me-1" (click)="searchTruckers()" [disabled]="truckerSearchParams.customerName.length < 2 && !truckerSearchParams.city && !truckerSearchParams.customerCode">
                    Search
                </button>
                <button type="button" class="btn btn-sm btn-primary ms-1 me-1" (click)="clearSearchParameters()" [hidden]="!truckerSearchParams.hasChanged">
                    Clear Filters
                </button>
            </div>
        </div>
    </form>
</div>

<!-- Results + Detail -->
<div class="row ms-1 me-1">
    <!-- Trucker list -->
    <div class="col-sm-5 p-0">
        <div id="TruckersTable" class="border rounded p-2 table-container" [style.height.px]="tableHeight">
            <table class="table table-sm table-borderless table-hover mb-0">
                <thead>
                    <tr>
                        <th style="width:5%"></th>
                        <th style="width:45%">Name</th>
                        <th style="width:35%">City</th>
                        <th style="width:15%">CTRM Code</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="truckerList.length === 0">
                        <td colspan="4" class="text-center">No rows to display</td>
                    </tr>
                    <tr *ngFor="let item of truckerList" [class.selected]="item.isSelected" (click)="selectTrucker(item)">
                        <td class="text-center">
                            <i class="fa-star"
                               [ngClass]="isFavoriteTrucker(item) ? 'fa-solid' : 'fa-regular'"
                               [style.color]="isFavoriteTrucker(item) ? 'gold' : 'grey'"
                               style="cursor: pointer;"
                               (click)="toggleFavoriteTrucker(item, $event)"
                               [title]="isFavoriteTrucker(item) ? 'Remove from favorites' : 'Add to favorites'">
                            </i>
                        </td>
                        <td>{{ item.customerName }}</td>
                        <td>{{ item.city }}</td>
                        <td>{{ item.customerCode }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Trucker details -->
    <div class="col-sm-7" *ngIf="selectedTrucker">
        <div class="row">
            <!-- Address / meta -->
            <div class="col-sm-6">
                <div class="border rounded p-1">
                    <div class="mb-1">
                        <label for="Address1" class="form-label small">Address</label>
                        <input id="Address1" type="text" class="form-control form-control-sm" [(ngModel)]="trucker.addressLine1" [ngModelOptions]="{standalone: true}" disabled />
                    </div>
                    <div class="mb-1">
                        <label for="Address2" class="form-label small">Address 2</label>
                        <input id="Address2" type="text" class="form-control form-control-sm" [(ngModel)]="trucker.addressLine2" [ngModelOptions]="{standalone: true}" disabled />
                    </div>

                    <div class="row g-1 mb-1">
                        <div class="col-10">
                            <label for="City" class="form-label small">City</label>
                            <input id="City" type="text" class="form-control form-control-sm" [(ngModel)]="trucker.city" [ngModelOptions]="{standalone: true}" disabled />
                        </div>
                        <div class="col-2">
                            <label for="State" class="form-label small">State</label>
                            <input id="State" type="text" class="form-control form-control-sm" [(ngModel)]="trucker.province" [ngModelOptions]="{standalone: true}" disabled />
                        </div>
                    </div>

                    <div class="row g-1 mb-1">
                        <div class="col-4">
                            <label for="ZipCode" class="form-label small">Zip</label>
                            <input id="ZipCode" type="text" class="form-control form-control-sm" [(ngModel)]="trucker.zipCode" [ngModelOptions]="{standalone: true}" disabled />
                        </div>
                        <div class="col-4">
                            <label for="CountryCode" class="form-label small">Country</label>
                            <input id="CountryCode" type="text" class="form-control form-control-sm" [(ngModel)]="trucker.countryCode" [ngModelOptions]="{standalone: true}" disabled />
                        </div>
                        <div class="col-4">
                            <label for="CtrmId" class="form-label small">CTRM ID</label>
                            <input id="CtrmId" type="text" class="form-control form-control-sm" [(ngModel)]="trucker.customerCode" [ngModelOptions]="{standalone: true}" disabled />
                        </div>
                    </div>

                    <div class="row g-1">
                        <div class="col-5">
                            <label for="CtrmPhone" class="form-label small">Main Phone</label>
                            <div class="position-relative">
                                <input id="CtrmPhone" type="text"
                                       class="form-control form-control-sm"
                                       [ngClass]="{'phone-invalid': trucker.telephone1ValidationStatus === 'failed'}"
                                       [(ngModel)]="trucker.phone" [ngModelOptions]="{standalone: true}"
                                       mask="(000) 000-0000"
                                       disabled />
                                @if (trucker.telephone1ValidationStatus === 'failed') {
                                    <i class="fa-solid fa-circle-exclamation phone-invalid-icon"
                                       title="Phone number could not be verified."></i>
                                }
                            </div>
                        </div>
                        <div class="col-2 d-flex align-items-end pb-1">
                            <div class="form-check" style="pointer-events: none;">
                                <input id="IsMainPhoneTextable" type="checkbox" class="form-check-input" [(ngModel)]="trucker.isTelephone1TextEnabled" [ngModelOptions]="{standalone: true}" />
                                <label class="form-label small m-0" for="IsMainPhoneTextable">Textable</label>
                            </div>
                        </div>
                        <div class="col-5">
                            <label for="currentcy" class="form-label small">Preferred Currency</label>
                            <input id="currentcy" type="text" name="currency" class="form-control form-control-sm" [(ngModel)]="trucker.currency" disabled />
                        </div>
                    </div>

                    <div class="mt-2">
                        <label for="CtrmEmail" class="form-label small">Main Email</label>
                        <input id="CtrmEmail" type="text" class="form-control form-control-sm" [(ngModel)]="trucker.email" [ngModelOptions]="{standalone: true}" disabled />
                    </div>
                </div>
            </div>

            <!-- Compliance / notes -->
            <div class="col-sm-6 p-0">
                <div class="border rounded p-1 mb-1">
                    <div class="row g-1 mb-1">
                        <div class="col-6">
                            <label class="form-label small">Compliance</label>
                            <span class="ms-2 fw-bold" [ngClass]="getComplianceClass()" *ngIf="trucker.customerId > 0">
                                <i class="fa-solid fa-circle"></i>
                            </span>
                            <input type="text" class="form-control form-control-sm" [value]="trucker.compliance.compliant" disabled />
                        </div>
                        <div class="col-6">
                            <label class="form-label small">Safety Rating</label>
                            <input type="text" class="form-control form-control-sm" [value]="trucker.compliance.safetyRating" disabled />
                        </div>
                    </div>

                    <div class="row g-1">
                        <div class="col-6">
                            <label class="form-label small">Haul Contract</label>
                            <input type="text" class="form-control form-control-sm" [value]="trucker.compliance.haulContract" disabled />
                        </div>
                        <div class="col-6">
                            <label class="form-label small">Insurance</label>
                            <input type="text" class="form-control form-control-sm" [value]="trucker.compliance.insurance" disabled />
                        </div>
                    </div>

                    <div class="row g-1 mt-1">
                        <div class="col-6">
                            <label class="form-label small">Insurance Expire Date</label>
                            <input type="text" class="form-control form-control-sm" [value]="trucker.compliance.insuranceExpireDate" disabled />
                        </div>
                        <div class="col-6">
                            <label class="form-label small">Last Updated</label>
                            <input type="text" class="form-control form-control-sm" [value]="trucker.compliance.lastUpdated" disabled />
                        </div>
                    </div>
                </div>

                <div class="border rounded p-1">
                    <div class="mb-1">
                        <label for="TruckerComments" class="form-label small">Trucker Notes</label>
                        <textarea id="TruckerComments" rows="3" class="form-control form-control-sm" [(ngModel)]="trucker.comments" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateHasTruckerChanged()"></textarea>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="d-flex align-items-center">
                                <input class="form-check-input me-2" type="checkbox" id="IsRogerEnabled" [(ngModel)]="trucker.isRogerEnabled" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateHasTruckerChanged()" />
                                <label class="form-label small m-0" for="IsRogerEnabled">Roger Enabled</label>
                            </div>
                        </div>
                        <div class="col">
                            <div class="d-flex align-items-center justify-content-end">
                                <input class="form-check-input me-2" type="checkbox" id="IsActiveCheckbox" [(ngModel)]="trucker.isActive" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateHasTruckerChanged()" />
                                <label class="form-label small m-0" for="IsActiveCheckbox">Trucker Active</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Contacts -->
        <div class="row mt-2">
            <div class="col-12 pe-0">
                <div class="border rounded p-1">
                    <div class="row g-2">
                        <!-- Left: contact list -->
                        <div class="col-sm-4">
                            <div class="d-flex justify-content-between align-items-end mb-1">
                                <label class="form-label small">Contacts</label>
                                <!-- Primary toggle -->
                                <div class="form-check contact-primary position-relative"
                                     [style.pointer-events]="(!selectedTruckerContact.email || !selectedTruckerContact.email.trim()) ? 'none' : 'auto'">

                                    <div *ngIf="!selectedTruckerContact.email || !selectedTruckerContact.email.trim()"
                                         class="position-absolute"
                                         style="top: 0; left: 0; right: 0; bottom: 0; z-index: 1; cursor: pointer; pointer-events: all;"
                                         (click)="onPrimaryAreaClick()">
                                    </div>

                                    <input class="form-check-input"
                                           type="checkbox"
                                           id="IsPrimary"
                                           name="IsPrimary"
                                           [(ngModel)]="selectedTruckerContact.isPrimary" [ngModelOptions]="{standalone: true}"
                                           [disabled]="!selectedTruckerContact.email || !selectedTruckerContact.email.trim()"
                                           (change)="onPrimaryToggleForSelected()" />

                                    <label class="form-label small"
                                           [ngClass]="{'text-muted': !selectedTruckerContact.email || !selectedTruckerContact.email.trim()}">
                                        Primary Contact
                                    </label>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-sm btn-primary me-1"
                                            (click)="deleteContact(selectedTruckerContact?.contactId)"
                                            [disabled]="!selectedTruckerContact?.contactName">
                                        Delete
                                    </button>
                                    <button type="button" class="btn btn-sm btn-primary" (click)="newContact()">
                                        New
                                    </button>
                                </div>
                            </div>
                            <div class="contacts-list border rounded" style="max-height: 200px; overflow-y: auto;">
                                <div *ngIf="!(trucker?.contactList?.length)" class="text-center py-2 small text-muted">
                                    No contacts
                                </div>

                                <div *ngFor="let item of trucker.contactList"
                                     class="d-flex align-items-center justify-content-between px-2 py-1 contact-row"
                                     [class.selected]="item === selectedTruckerContact"
                                     (click)="selectTruckerContact(item)">
                                    <div class="text-truncate me-2" title="{{ item.contactName }}">
                                        {{ item.contactName || '(no name)' }}
                                    </div>

                                    <div class="ms-auto">
                                        <span *ngIf="item.isPrimary" class="badge bg-primary">Primary</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Middle -->
                        <div class="col-sm-5 pt-2">
                            <!-- Header row: Name/ Default Dispatch  -->
                            <div class="row align-items-end mb-1">
                                <div class="col-8">
                                    <label class="form-label small" for="ContactName">Name</label>
                                    <input id="ContactName"
                                           #contactNameInput
                                           type="text"
                                           class="form-control form-control-sm"
                                           [(ngModel)]="selectedTruckerContact.contactName" [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="updateHasTruckerChanged()" />
                                </div>
                            </div>

                            <!-- Phone 1 -->
                            <div class="row g-2 align-items-center mb-1">
                                <div class="col-6">
                                    <label class="form-label small m-0" for="ContactPhone1">Phone 1</label>
                                    <div class="position-relative">
                                        <input id="ContactPhone1"
                                               name="ContactPhone1"
                                               #contactPhone1="ngModel"
                                               type="text"
                                               class="form-control form-control-sm"
                                               [ngClass]="{'phone-landline': isPhone1Landline}"
                                               [(ngModel)]="selectedTruckerContact.phone1" [ngModelOptions]="{standalone: true}"
                                               (ngModelChange)="onPhone1Changed()"
                                               mask="(000) 000-0000"
                                               minlength="10"
                                               pattern="^(?:\([2-9][0-8][0-9]\)\s?|[2-9][0-8][0-9][\s.-]?)?[2-9](?!11)[0-9]{2}[-.\s]?[0-9]{4}$"
                                               [validation]="false"
                                               [ngModelOptions]="{updateOn: 'blur'}" />
                                        @if (isPhone1Landline) {
                                            <i class="fa-solid fa-circle-info phone-landline-icon"
                                               title="This is not a mobile number and is not textable."></i>
                                        }
                                    </div>
                                    <div *ngIf="contactPhone1.invalid && (contactPhone1.dirty || contactPhone1.touched) && contactPhone1.errors['pattern']"
                                         class="text-danger p-1" style="font-size:0.875rem;">
                                        Phone number is not valid.
                                    </div>
                                    @if (phone1ErrorMessage) {
                                        <div class="text-danger p-1" style="font-size:0.875rem;">
                                            {{ phone1ErrorMessage }}
                                        </div>
                                    }
                                </div>
                                <div class="col-3">
                                    <div class="form-check mt-4 textable-disabled">
                                        <input id="IsPhone1Textable" type="checkbox" class="form-check-input"
                                               [(ngModel)]="selectedTruckerContact.isPhone1TextEnabled" [ngModelOptions]="{standalone: true}"
                                               disabled />
                                        <label class="form-label small m-0 text-muted" for="IsPhone1Textable">Textable</label>
                                    </div>
                                </div>
                                <div class="col-3 d-flex justify-content-end">
                                    <div class="form-check form-switch switch-left mt-4 d-flex align-items-center flex-row-reverse gap-2"
                                         [ngClass]="{
                                            'disabled-toggle': !selectedTruckerContact.isPhone1TextEnabled,
                                            'text-muted': !selectedTruckerContact.isPhone1TextEnabled
                                        }">
                                        <input id="IsPhone1Default" type="checkbox" class="form-check-input"
                                               [(ngModel)]="selectedTruckerContact.isPhone1Default" [ngModelOptions]="{standalone: true}"
                                               [disabled]="!selectedTruckerContact.isPhone1TextEnabled"
                                               (ngModelChange)="onPhone1TextableChanged()" />
                                        <label class="form-label small m-0" for="IsPhone1Default">Default</label>
                                    </div>
                                </div>
                            </div>

                            <!-- Phone 2 -->
                            <div class="row g-2 align-items-center mb-1">
                                <div class="col-6">
                                    <label class="form-label small m-0" for="ContactPhone2">Phone 2</label>
                                    <div class="position-relative">
                                        <input id="ContactPhone2"
                                               name="ContactPhone2"
                                               #contactPhone2="ngModel"
                                               type="text"
                                               class="form-control form-control-sm"
                                               [ngClass]="{'phone-landline': isPhone2Landline}"
                                               [(ngModel)]="selectedTruckerContact.phone2" [ngModelOptions]="{standalone: true}"
                                               (ngModelChange)="onPhone2Changed()"
                                               mask="(000) 000-0000"
                                               minlength="10"
                                               pattern="^(?:\([2-9][0-8][0-9]\)\s?|[2-9][0-8][0-9][\s.-]?)?[2-9](?!11)[0-9]{2}[-.\s]?[0-9]{4}$"
                                               [validation]="false"
                                               [ngModelOptions]="{updateOn: 'blur'}" />
                                        @if (isPhone2Landline) {
                                            <i class="fa-solid fa-circle-info phone-landline-icon"
                                               title="This is not a mobile number and is not textable."></i>
                                        }
                                    </div>
                                    <div *ngIf="contactPhone2.invalid && (contactPhone2.dirty || contactPhone2.touched) && contactPhone2.errors['pattern']"
                                         class="text-danger p-1" style="font-size:0.875rem;">
                                        Phone number is not valid.
                                    </div>
                                    @if (phone2ErrorMessage) {
                                        <div class="text-danger p-1" style="font-size:0.875rem;">
                                            {{ phone2ErrorMessage }}
                                        </div>
                                    }
                                </div>
                                <div class="col-3">
                                    <div class="form-check mt-4 textable-disabled">
                                        <input id="IsPhone2Textable" type="checkbox" class="form-check-input"
                                               [(ngModel)]="selectedTruckerContact.isPhone2TextEnabled" [ngModelOptions]="{standalone: true}"
                                               disabled />
                                        <label class="form-label small m-0 text-muted" for="IsPhone2Textable">Textable</label>
                                    </div>
                                </div>
                                <div class="col-3 d-flex justify-content-end">
                                    <div class="form-check form-switch switch-left mt-4 d-flex align-items-center flex-row-reverse gap-2"
                                         [ngClass]="{
                                          'disabled-toggle': !selectedTruckerContact.isPhone2TextEnabled,
                                          'text-muted': !selectedTruckerContact.isPhone2TextEnabled
                                        }">
                                        <input id="IsPhone2Default" type="checkbox" class="form-check-input"
                                               [(ngModel)]="selectedTruckerContact.isPhone2Default" [ngModelOptions]="{standalone: true}"
                                               [disabled]="!selectedTruckerContact.isPhone2TextEnabled"
                                               (ngModelChange)="onPhone2DefaultChanged()" />
                                        <label class="form-label small m-0" for="IsPhone2Default">Default</label>
                                    </div>
                                </div>
                            </div>

                            <!-- Fax -->
                            <div class="row g-2 align-items-center mb-1">
                                <div class="col-6">
                                    <label class="form-label small m-0" for="ContactFax">Fax</label>
                                    <input id="ContactFax"
                                           name="ContactFax"
                                           type="text"
                                           class="form-control form-control-sm"
                                           #contactFax="ngModel"
                                           [(ngModel)]="selectedTruckerContact.fax" [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="updateHasTruckerChanged()"
                                           mask="(000) 000-0000"
                                           minlength="10" maxlength="25" pattern="^[0-9]{10,}$"
                                           [validation]="false" [ngModelOptions]="{updateOn: 'blur'}" />
                                    <div *ngIf="contactFax.invalid && (contactFax.dirty || contactFax.touched) && contactFax.errors['pattern']"
                                        class="text-danger p-1" style="font-size:0.875rem;">
                                        Phone number is not valid.
                                    </div>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-3 d-flex justify-content-end"></div>
                            </div>

                            <!-- Email -->
                            <div class="row g-2 align-items-center">
                                <div class="col-8">
                                    <label class="form-label small m-0" for="ContactEmail">Email Address</label>
                                    <input id="ContactEmail"
                                           #contactEmail="ngModel"
                                           type="text"
                                           class="form-control form-control-sm"
                                           [ngClass]="{'border-warning': showEmailWarning}"
                                           [(ngModel)]="selectedTruckerContact.email" [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="onEmailChanged()"
                                           maxlength="50"
                                           pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                                           [ngModelOptions]="{updateOn: 'blur'}" />

                                    <div *ngIf="contactEmail.invalid && (contactEmail.dirty || contactEmail.touched) && contactEmail.errors['pattern']"
                                         class="text-danger small mt-1">
                                        Please enter a valid email address.
                                    </div>

                                    <div *ngIf="showEmailWarning" class="alert alert-warning alert-sm mt-2 mb-0 py-1 px-2">
                                        <small>Email is required for a primary contact.</small>
                                    </div>
                                </div>
                                <div class="col-4 d-flex justify-content-end">
                                    <div class="form-check form-switch switch-left mt-4 d-flex align-items-center flex-row-reverse gap-2">
                                        <input id="IsEmailDefault" type="checkbox" class="form-check-input toggle-pill"
                                               [(ngModel)]="selectedTruckerContact.isEmailDefault" [ngModelOptions]="{standalone: true}"
                                               (ngModelChange)="onEmailDefaultChanged()"
                                               [disabled]="!isEmailDefaultEnabled()" />
                                        <label class="form-label small m-0" for="IsEmailDefault">Default</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Right: Notes + actions -->
                        <div class="col-sm-3 pt-2 d-flex flex-column">
                            <label class="form-label small" for="ContactNotes">Notes</label>
                            <textarea id="ContactNotes" rows="8" class="form-control form-control-sm" [(ngModel)]="selectedTruckerContact.notes" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateHasTruckerChanged()"></textarea>

                            <div class="mt-auto pt-2 text-end">
                                <div class="text-danger small mb-1" *ngIf="hasTruckerChangedStatus">Unsaved Changes Pending</div>
                                <button type="button" class="btn btn-sm btn-secondary me-1" (click)="revertContactChanges()" *ngIf="hasTruckerChangedStatus">
                                    Cancel
                                </button>
                                <button type="button" class="btn btn-sm btn-primary" (click)="saveTrucker()" [disabled]="!hasTruckerChangedStatus || (contactPhone1.invalid || contactPhone2.invalid || contactFax.invalid || contactEmail.invalid)">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<toast-notification #toastNotification></toast-notification>